import { isSurveyAiPreviewEnabledForTenant } from 'helpers';

export const isSurveyAiPreviewEnabled = tenantId => {
  const currentTenantId =
    tenantId ??
    window.localStorage.getItem('GCM-tenantId');

  return isSurveyAiPreviewEnabledForTenant(currentTenantId);
};
